<template>
  <v-tooltip bottom>
    <template v-slot:activator="{on}">
      <slot v-bind:on="on"></slot>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    text: String
  },
  name: "ButtonToltip"
}
</script>


<style scoped>

</style>
